import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderBatchItem extends ApiBase {
	constructor(store) {
		super(store, `${ACTIVE_BASE_REST}/order/batchItem`)
	}

	convert(model, showProgress) {
		return this._request({
			action: 'convert',
			body: model,
			method: 'POST',
			showProgress
		})
	}

	updateFurniture(id, model, showProgress) {
		return this._request({
			action: `${id}/furniture`,
			body: model,
			method: 'PUT',
			showProgress
		})
	}

	updateCargo(id, model, showProgress) {
		return this._request({
			action: `${id}/cargo`,
			body: model,
			method: 'PUT',
			showProgress
		})
	}

	updateFreight(id, model, showProgress) {
		return this._request({
			action: `${id}/freight`,
			body: model,
			method: 'PUT',
			showProgress
		})
	}

	createFurniture(model, showProgress) {
		return this._request({
			action: 'create/furniture',
			body: model,
			method: 'POST',
			showProgress
		})
	}

	createCargo(model, showProgress) {
		return this._request({
			action: 'create/cargo',
			body: model,
			method: 'POST',
			showProgress
		})
	}

	createFreight(model, showProgress) {
		return this._request({
			action: 'create/freight',
			body: model,
			method: 'POST',
			showProgress
		})
	}
}
